import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { I18N } from "oc-I18N";
import React from "react";

import { AuswahlVerteilungsstrategie } from "../grundriss/AuswahlVerteilungsstrategie";
import { MenuItemSmallButton } from "./MenuItemSmallButton";

export function ZaunCircleMenuItemVerteilungsstrategie() {
  const agt = APP.arrangement;
  const isShown = agt.selectedObjects.some((p) => p.isElement || p.isEmpty);
  if (!isShown) {
    return null;
  }

  return (
    <ZaunCircleMenuItem dataButtonKey={I18N("aria::Verteilungsstrategie")}>
      <div className="flex-column" role="group" aria-label={I18N("aria::Verteilungsoptionen")}>
        <AuswahlVerteilungsstrategie />
        <ElementeGleichmäßigVerteilen />
      </div>
    </ZaunCircleMenuItem>
  );
}

export function ElementeGleichmäßigVerteilen() {
  const agt = APP.arrangement;
  const selectedObject = agt.selectedObjects[0];
  const isShown =
    agt.verteilungsstrategieAuswahlwert?.Key === "Individuell" &&
    selectedObject &&
    (selectedObject.isElement || selectedObject.isEmpty) &&
    selectedObject.segment?.istGleichmäßigeVerteilungMöglich(selectedObject);

  if (!isShown) {
    return null;
  }
  return (
    <MenuItemSmallButton
      onClick={() => {
        agt.verteileBauseitsKürzbareElementeGleichmäßig(agt.selectedObjects);
        APP.dirty();
        APP.logUserAction({ action: "elementeGleichmäßigVerteilenButton" });
      }}
    >
      {I18N("Elemente gleichmäßig verteilen")}
    </MenuItemSmallButton>
  );
}
